const {Component} = require("react");
const PropTypes = require("prop-types");
const router = require("app/services/router");
const checkout = require("app/pipelines/checkout/products")
const checkoutManager = require("app/pipelines/checkout/manager");
const Trans = require('app/components/trans/Trans');

class CartItem extends Component {

	static get propTypes() {
		return {
			counter: PropTypes.number
		}
	}

	static get defaultProps() {
		return {
			counter: 0
		}
	}

	constructor(props) {
		super(props);
		this.state = {
			counter: props.counter
		};
	}

	get className() {
		let classList = ["cart-link"];

		if (this.state.counter > 0) {
			classList.push("has-items");
		}

		return classList.join(" ");
	}

	componentDidMount() {
		checkout.change.pipe(payload => {
			this.setCounter(payload.items.length);
			return payload;
		});
	}

	increaseCounter() {
		return this.setCounter(this.state.counter + 1);
	}

	decreaseCounter() {
		return this.setCounter(this.state.counter - 1);
	}

	setCounter(value) {
		if (value < 0) {
			value = 0;
		}

		this.setState({counter: value});
		return this;
	}

	_onClick = (e) => {
		e.preventDefault();
		checkoutManager.toggle.dispatch({cart: "product"});
	};

	renderCounter() {
		if (this.state.counter <= 0) {
			return;
		}

		return (<span className="counter">{this.state.counter}</span>)
	}

	render() {
		return (
			<a className={this.className} href="#" onClick={this._onClick}>
              <div className={'sprite'} lazy-load={'true'} critical={'true'}
                   cssbg={router.url("img/icons/icons-black@2x.png")}/>
              <p><Trans>Kurv</Trans></p>
              {this.renderCounter()}
            </a>
		);
	}

}

module.exports = CartItem;
